/* istanbul ignore file */
export const dashboardPathName = 'dashboard';
